import { useState, useRef } from "react";
import styles from "../style/faqs.module.css";
import { Link } from "react-router";
import { companyName } from "../Const";

const ICON_PATHS = {
    email: (
        <>
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <polyline points="2,4 12,13 22,4" />
        </>
    ),
    phone: <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.22 2.18 2 2 0 012.18 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.09a16 16 0 006 6l.56-.56a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />,
    heart: <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />,
    search: (
        <>
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </>
    ),
    plus: (
        <>
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </>
    ),
    minus: <line x1="5" y1="12" x2="19" y2="12" />,
    chevronUp: <polyline points="18 15 12 9 6 15" />,
    chevronDown: <polyline points="6 9 12 15 18 9" />,
    chevronRight: <polyline points="9 18 15 12 9 6" />,
    question: (
        <>
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3" />
            <line x1="12" y1="17" x2="12.01" y2="17" strokeWidth="3" strokeLinecap="round" />
        </>
    ),
    user: (
        <>
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </>
    ),
    home: (
        <>
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
            <polyline points="9,22 9,12 15,12 15,22" />
        </>
    ),
    agent: (
        <>
            <circle cx="12" cy="8" r="4" />
            <path d="M6 20v-2a4 4 0 014-4h4a4 4 0 014 4v2" />
            <path d="M16 3.13a4 4 0 010 7.75" />
        </>
    ),
    searchAlt: (
        <>
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </>
    ),
    building: (
        <>
            <rect x="4" y="2" width="16" height="20" rx="1" />
            <line x1="9" y1="7" x2="9.01" y2="7" strokeWidth="3" strokeLinecap="round" />
            <line x1="15" y1="7" x2="15.01" y2="7" strokeWidth="3" strokeLinecap="round" />
            <line x1="9" y1="12" x2="9.01" y2="12" strokeWidth="3" strokeLinecap="round" />
            <line x1="15" y1="12" x2="15.01" y2="12" strokeWidth="3" strokeLinecap="round" />
            <path d="M9 17h6v5H9z" />
        </>
    ),
    headset: (
        <>
            <path d="M3 18v-6a9 9 0 0118 0v6" />
            <path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z" />
        </>
    ),
    contact: (
          <path fill="none" stroke-width="2" d="M5,12 C3.343,12 2,10.657 2,9 C2,7.343 3.343,6 5,6 C6.657,6 8,7.343 8,9 C8,10.657 6.657,12 5,12 Z M9,18 L9,16 C9,13.7504 7.2128,12 4.964,12 L5.0184,12 C2.7688,12 1,13.7504 1,16 L1,18 M12,7 L24,7 M12,17 L22,17 M12,12 L19,12"></path>

    ),
};

const Icon = ({ name, className = "" }) => {
    const path = ICON_PATHS[name];
    if (!path) return null;
    return (
        <span className={`${styles.icon} ${className}`}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                {path}
            </svg>
        </span>
    );
};
// ── Data ──────────────────────────────────────────────────────────────────────
const CATEGORIES = [
    { id: "general", label: "General Questions", icon: "question", count: 5 },
    { id: "listings", label: "Property Listings", icon: "home", count: 5 },
    { id: "agent", label: "Agent & Broker", icon: "agent", count: 3 },
    { id: "search", label: "Property Search", icon: "searchAlt", count: 2 },
    { id: "developers", label: "Developers & Projects", icon: "building", count: 2 },
    { id: "contacts", label: "Contact Information", icon: "contact", count: 1 },
];

const FAQ_DATA = {
    general: [
        { id: 1, q: `What is ${companyName}?`, a: `${companyName} is a modern real estate platform that connects buyers, sellers, investors, brokers, developers, landlords, and tenants through verified property listings and advanced property search tools.`, open: true },
        { id: 2, q: `Is ${companyName} free to use?`, a: `Yes, ${companyName} offers a free tier for buyers and tenants. Agents and developers may require a subscription for premium listing features and advanced analytics.` },
        { id: 3, q: `Which countries or cities does ${companyName} support?`, a: "Property seekers can browse listings, search properties, and contact agents free of charge. Some premium services for brokers and developers may require subscription plans." },
        { id: 4, q: `Can I list my property on ${companyName}?`, a: "Yes. Property owners, brokers, and developers can create listings after registering an account and completing verification requirements." },
        { id: 5, q: "Are property listings verified?", a: "We encourage brokers and agencies to provide verified information. However, users should independently verify property details before making transactions." },
    ],
    listings: [
        { id: 6, q: "How do I post a property listing?", a: <>After logging in: Go to Dashboard → Click "Add Property" → Upload property details and images → Submit your listing for review.</> },
        {
            id: 7,
            q: "What property types can I list?",
            a: (
                <>
                    You can list:{" "}
                    <ul>
                        <li>Apartments</li>
                        <li>Villas</li>
                        <li>Townhouses</li>
                        <li>Commercial Offices</li>
                        <li>Shops</li>
                        <li>Warehouses</li>
                        <li>Lands & Plots</li>
                        <li>Penthouses</li>
                        <li>Hotel Apartments</li>
                    </ul>
                </>
            ),
        },
        { id: 8, q: "How many images can I upload?", a: "You can upload multiple high-quality property images along with videos, floor plans, and property documents to enhance your listing." },
        {
            id: 9,
            q: "Why was my property listing rejected?",
            a: (
                <>
                    Listings may be rejected due to:
                    <ul>
                        <li>Incomplete information</li>
                        <li>Duplicate properties</li>
                        <li>Misleading details</li>
                        <li>Poor image quality</li>
                        <li>Violation of platform policies</li>
                    </ul>
                </>
            ),
        },
        { id: 10, q: "Can I edit my property after publishing?", a: "Yes. You can edit property details anytime through your dashboard." },
    ],
    agent: [
        {
            id: 11,
            q: "How do I become a verified agent?",
            a: (
                <>
                    You may need to submit:
                    <ul>
                        <li>Brokerage License</li>
                        <li>RERA Information</li>
                        <li>Agency Documents</li>
                        <li>Government Identification</li>
                        <li>Verification helps build trust and visibility</li>
                    </ul>
                </>
            ),
        },
        {
            id: 12,
            q: "How do I receive buyer leads?",
            a: (
                <>
                    Interested buyers can contact you through:
                    <ul>
                        <li>Inquiry Forms</li>
                        <li>Phone Calls</li>
                        <li>WhatsApp</li>
                        <li>Email Requests</li>
                    </ul>
                    All inquiries are managed through your dashboard.
                </>
            ),
        },
        {
            id: 13,
            q: "How do I contact customer support?",
            a: (
                <>
                    You can contact us through:
                    <ul>
                        <li>Contact Form</li>
                        <li>Email Support</li>
                        <li>WhatsApp</li>
                        <li>Phone Support</li>
                    </ul>
                </>
            ),
        },
    ],
    search: [
        {
            id: 14,
            q: "How do I search for properties?",
            a: (
                <>
                    Use filters such as:
                    <ul>
                        <li>Location</li>
                        <li>Property Type</li>
                        <li>Price Range</li>
                        <li>Bedrooms</li>
                        <li>Bathrooms</li>
                        <li>Furnishing</li>
                        <li>Developer</li>
                    </ul>
                </>
            ),
        },
        { id: 15, q: "Can I save favorite properties?", a: "Yes. Registered users can save favorite listings for future viewing." },
    ],
    developers: [
        {
            id: 16,
            q: "Can developers showcase new projects?",
            a: (
                <>
                    Yes. Developers can promote:
                    <ul>
                        <li>Off-plan Projects</li>
                        <li>New Launches</li>
                        <li>Investment Opportunities</li>
                        <li>Featured Communities through dedicated project pages</li>
                    </ul>
                </>
            ),
        },
        { id: 17, q: "Who is responsible for property verification?", a: "Users, buyers, and investors should independently verify all legal documents, ownership records, and property information before proceeding." },
    ],
    contacts: [
        {
            id: 18,
            q: `${companyName} Support`,
            a: (
                <ul>
                    <li>
                        <b>Office Address:</b>5th Floor Office No 510,Opal Tower, Business Bay, Dubai, UAE
                    </li>
                    <li>
                        <b>Email:</b> info@leadtracks.ai
                    </li>
                    <li>
                        <b>Phone: </b>+971 50 361 5200
                    </li>
                </ul>
            ),
        },
    ],
};

// ── FAQItem ───────────────────────────────────────────────────────────────────
const FAQItem = ({ item, index }) => {
    const [open, setOpen] = useState(item.open || false);
    return (
        <>
        <div className={`${styles.faqItem} ${open ? styles.faqItemOpen : ""}`}>
            <button className={styles.faqQuestion} onClick={() => setOpen((o) => !o)}>
                <span className={styles.faqNum}>{index}.</span>
                <span className={styles.faqQText}>{item.q}</span>
                <span className={`${styles.faqToggle} ${open ? styles.faqToggleOpen : ""}`}>
                    <Icon name={open ? "minus" : "plus"} />
                </span>
            </button>
            {open && <div className={styles.faqAnswer}>{item.a}</div>}
        </div>
        </>
    );
};

// ── FAQPanel — header has up/down arrow to collapse/expand the whole section ──
const FAQPanel = ({ cat, expanded, onToggle }) => (
    <div className={`${styles.faqPanel} ${expanded ? styles.faqPanelExpanded : styles.faqPanelCollapsed}`}>
        <button className={styles.faqPanelHeader} onClick={onToggle}>
            <span className={styles.faqPanelHeaderLeft}>
                <Icon name={cat.icon} />
                <h2 className={styles.faqPanelTitle}>{cat.label}</h2>
            </span>
            {/* UP arrow when open, DOWN arrow when closed */}
            <span className={styles.panelChevron}>
                <Icon name={expanded ? "chevronUp" : "chevronDown"} />
            </span>
        </button>

        {expanded && (
            <div className={styles.faqList}>
                {FAQ_DATA[cat.id].map((item, i) => (
                    <FAQItem key={item.id} item={item} index={i + 1} />
                ))}
            </div>
        )}
    </div>
);

// ── Page ──────────────────────────────────────────────────────────────────────
export default function Faq() {
    const [openPanel, setOpenPanel] = useState("general");
    const sectionRefs = useRef({});

    const togglePanel = (id) => {
        setOpenPanel((prev) => (prev === id ? null : id));
    };
    const handleCategoryClick = (id) => {
        setOpenPanel(id);
        setTimeout(() => {
            const el = sectionRefs.current[id];
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 50);
    };

    return (
        <div className={styles.page}>
            <section className={styles.hero}>
                <div className="container">
                    <div className={styles.heroContent}>
                        <div className={styles.breadcrumb}>
                            <span>Home</span>
                            <Icon name="chevronRight" />
                            <span className={styles.breadcrumbActive}>FAQ</span>
                        </div>
                        <h1 className={styles.heroTitle}>
                            Frequently Asked
                            <br />
                            <span className={styles.heroTitleOrange}>Questions</span>
                        </h1>
                        <p className={styles.heroSub}>
                            Find answers to common questions about {companyName},
                            <br />
                            our services, and how we help you discover the perfect property.
                        </p>
                    </div>
                </div>
            </section>

            <section className={styles.main_section}>
                <div className="container">
                    <div className={styles.bodyInner}>
                        <aside className={styles.sidebar}>
                            <div className={styles.sideCard}>
                                <h3 className={styles.sideTitle}>Categories</h3>
                                <ul className={styles.catList}>
                                    {CATEGORIES.map((cat) => (
                                        <li key={cat.id}>
                                            <button className={`${styles.catItem} ${openPanel === cat.id ? styles.catItemActive : ""}`} onClick={() => handleCategoryClick(cat.id)}>
                                                <Icon name={cat.icon} className={styles.catIcon} />
                                                <span className={styles.catLabel}>{cat.label}</span>
                                                <span className={styles.catBadge}>{cat.count}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className={styles.helpCard}>
                                <div className={styles.helpCardTop}>
                                    <div className={styles.helpIcon}>
                                        <Icon name="headset" />
                                    </div>
                                    <h4 className={styles.helpTitle}>Still Need Help?</h4>
                                </div>
                                <p className={styles.helpText}>Can't find the answer you're looking for? Our support team is here to help you.</p>
                                <Link to="/contact-us">
                                    <button className="button w-100">Contact Support</button>
                                </Link>
                            </div>
                        </aside>
                        <section className={styles.faqMain}>
                            {CATEGORIES.map((cat) => (
                                <div key={cat.id} ref={(el) => (sectionRefs.current[cat.id] = el)}>
                                    <FAQPanel cat={cat} expanded={openPanel === cat.id} onToggle={() => togglePanel(cat.id)} />
                                </div>
                            ))}
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}
